import React from 'react';

export function FullPageLoader(){
    return <div className="container my-4 text-center">
            <i className="fa fa-spin fa-circle-notch"></i> Carregando...
        </div>
}